import { useContext } from 'react';

import { AlertContext } from './AlertContext';
import { AuthenticationContext } from './AuthenticationContext';
import { PermissionsContext } from './PermissionsContext';
import { SidebarContext } from './SidebarContext';

const useAuthentication = () => useContext(AuthenticationContext);
const usePermissions = () => useContext(PermissionsContext);
const useSidebar = () => useContext(SidebarContext);
const useAlert = () => useContext(AlertContext);

export {
  useAlert,
  useAuthentication,
  usePermissions,
  useSidebar,
};
